{
  "id": "castles",
  "name": "Old World",
  "backgroundImage": "castles",
  "opaqueTerritoryFills": true,
  "hideAdjacencyLines": true,
  "viewBox": {
    "x": 22,
    "y": -3,
    "width": 1325.1,
    "height": 1056
  },
  "backdropColor": {
    "light": "#e9dcb8",
    "dark": "#24251f",
    "topBar": true
  },
  "gameLayout": {
    "playerBarPosition": "center"
  },
  "edgeConfig": {
    "internalBorderWidth": 8,
    "regionBorderWidth": 11.7,
    "bridgeStrokeWidth": 0
  },
  "regions": [
    {
      "id": "austria-hungary",
      "name": "Habsburg",
      "bonus": 4,
      "shape": "M 1065.6 642.5 L 1063.3 638.9 L 1060.9 635.4 L 1058.2 632.2 L 1055.3 629.1 L 1052.2 626.2 L 1048.9 623.5 L 1045.4 621.0 L 1041.8 618.8 L 911.9 543.7 L 904.0 539.9 L 896.0 537.2 L 887.7 535.6 L 879.3 535.0 L 871.0 535.6 L 862.7 537.2 L 854.6 539.9 L 846.9 543.7 L 717.0 618.7 L 699.8 633.2 L 688.5 652.7 L 684.6 674.9 L 684.5 825.0 L 686.8 841.8 L 693.2 857.5 L 703.5 871.0 L 717.0 881.3 L 732.7 887.8 L 749.5 890.0 L 766.3 887.8 L 782.0 881.3 L 1041.8 731.3 L 1052.5 723.6 L 1061.2 714.2 L 1067.7 703.5 L 1072.1 691.8 L 1074.2 679.5 L 1073.8 667.0 L 1071.0 654.5 L 1065.6 642.5 Z",
      "territoryIds": [
        "bohemia",
        "galecia",
        "hungary",
        "trieste",
        "vienna"
      ],
      "color": "#cdcf59",
      "bonusAnchor": {
        "x": 972.21,
        "y": 583.36
      }
    },
    {
      "id": "balkans",
      "name": "The Porte",
      "bonus": 5,
      "shape": "M 1139.2 685.0 L 1122.4 687.2 L 1106.8 693.7 L 1105.3 694.6 L 1104.0 695.3 L 846.9 843.7 L 829.6 858.3 L 818.3 877.8 L 814.4 900.0 L 818.3 922.2 L 829.6 941.7 L 846.9 956.2 L 847.8 956.8 L 848.7 957.3 L 976.8 1031.3 L 992.6 1037.8 L 1009.3 1040.0 L 1269.1 1040.0 L 1285.9 1037.8 L 1301.6 1031.3 L 1315.1 1021.0 L 1325.4 1007.5 L 1331.9 991.8 L 1334.1 975.0 L 1331.9 958.2 L 1325.3 942.6 L 1315.1 929.2 L 1301.8 918.9 L 1204.2 862.5 L 1204.2 750.0 L 1202.0 733.2 L 1195.5 717.5 L 1185.2 704.0 L 1171.7 693.7 L 1156.0 687.2 L 1139.2 685.0 Z",
      "territoryIds": [
        "bulgaria",
        "greece",
        "montenegro",
        "romania",
        "serbia",
        "turkey"
      ],
      "color": "#880E4F",
      "bonusAnchor": {
        "x": 1225.54,
        "y": 849.11
      }
    },
    {
      "id": "britain",
      "name": "Albion",
      "bonus": 4,
      "shape": "M 229.9 10.0 L 221.3 10.6 L 213.0 12.3 L 205.0 15.0 L 197.4 18.7 L 190.4 23.4 L 184.1 29.0 L 178.5 35.3 L 173.7 42.5 L 43.7 267.5 L 41.7 271.3 L 40.0 275.2 L 38.5 279.2 L 37.2 283.2 L 36.3 287.3 L 35.6 291.5 L 35.1 295.7 L 35.0 300.0 L 35.6 308.6 L 37.3 316.9 L 40.0 324.9 L 43.7 332.4 L 48.4 339.4 L 53.9 345.8 L 60.3 351.4 L 67.5 356.2 L 197.4 431.3 L 201.3 433.3 L 205.1 435.0 L 209.1 436.5 L 213.1 437.8 L 217.2 438.7 L 221.4 439.4 L 225.6 439.9 L 229.9 440.0 L 234.6 439.8 L 239.3 439.3 L 243.9 438.5 L 248.4 437.3 L 252.8 435.8 L 257.2 434.0 L 261.4 431.9 L 265.4 429.4 L 392.3 356.3 L 399.5 351.4 L 405.8 345.8 L 411.4 339.4 L 416.1 332.4 L 419.8 324.9 L 422.5 316.9 L 424.2 308.6 L 424.8 300.0 L 424.2 291.4 L 422.5 283.1 L 419.8 275.1 L 416.1 267.5 L 411.4 260.5 L 405.9 254.2 L 399.5 248.6 L 392.3 243.8 L 390.9 242.9 L 389.9 242.4 L 389.0 242.0 L 388.0 241.5 L 387.1 241.1 L 386.1 240.6 L 385.2 240.2 L 384.2 239.8 L 294.9 196.7 L 294.3 83.5 L 294.4 82.4 L 294.5 81.4 L 294.6 80.3 L 294.7 79.3 L 294.8 78.2 L 294.8 77.1 L 294.9 76.1 L 294.9 75.0 L 293.6 61.9 L 289.8 49.7 L 283.8 38.7 L 275.9 29.0 L 266.2 21.1 L 255.2 15.1 L 243.0 11.3 L 229.9 10.0 Z",
      "territoryIds": [
        "ireland",
        "london",
        "scotland",
        "wales",
        "yorkshire"
      ],
      "color": "#1A237E",
      "bonusAnchor": {
        "x": 312.3,
        "y": 191.02
      }
    },
    {
      "id": "france",
      "name": "Gallia",
      "bonus": 5,
      "shape": "M 489.7 310.0 L 472.9 312.2 L 457.2 318.7 L 443.7 329.0 L 433.4 342.5 L 426.9 358.2 L 424.7 375.0 L 424.7 460.0 L 229.9 460.0 L 209.8 463.2 L 191.7 472.4 L 177.3 486.8 L 168.1 504.9 L 164.9 525.0 L 164.9 675.0 L 167.1 691.8 L 173.6 707.5 L 183.9 721.0 L 197.4 731.3 L 213.1 737.8 L 229.9 740.0 L 489.7 740.0 L 506.5 737.8 L 522.2 731.3 L 535.7 721.0 L 546.0 707.5 L 552.5 691.8 L 554.7 675.0 L 554.6 671.5 L 554.3 668.1 L 554.7 375.0 L 552.5 358.2 L 546.0 342.5 L 535.7 329.0 L 522.2 318.7 L 506.5 312.2 L 489.7 310.0 Z",
      "territoryIds": [
        "brittany",
        "burgundy",
        "gascony",
        "marseille",
        "netherlands",
        "paris"
      ],
      "color": "#7d148a",
      "bonusAnchor": {
        "x": 360.36,
        "y": 732.04
      }
    },
    {
      "id": "germany",
      "name": "Germania",
      "bonus": 4,
      "shape": "M 619.6 235.0 L 602.8 237.2 L 587.1 243.7 L 573.7 254.0 L 563.3 267.5 L 556.8 283.2 L 554.6 300.0 L 554.6 450.0 L 556.8 466.8 L 563.3 482.5 L 573.7 496.0 L 587.1 506.3 L 602.8 512.8 L 619.6 515.0 L 879.4 515.0 L 896.3 512.8 L 911.9 506.3 L 925.4 496.0 L 935.7 482.5 L 942.2 466.8 L 944.4 450.0 L 944.4 300.0 L 942.2 283.2 L 935.7 267.5 L 925.4 254.0 L 911.9 243.7 L 896.3 237.2 L 879.4 235.0 L 862.1 237.4 L 846.1 244.3 L 845.2 244.8 L 844.3 245.3 L 749.5 300.0 L 652.1 243.7 L 636.4 237.2 L 619.6 235.0 Z",
      "territoryIds": [
        "bavaria",
        "berlin",
        "prussia",
        "rhine",
        "saxony"
      ],
      "color": "#a47841",
      "bonusAnchor": {
        "x": 750.04,
        "y": 277.27
      }
    },
    {
      "id": "italy",
      "name": "Italia",
      "bonus": 3,
      "shape": "M 619.6 535.0 L 602.8 537.2 L 587.1 543.7 L 573.7 554.0 L 563.3 567.5 L 556.8 583.2 L 554.6 600.0 L 554.6 900.0 L 558.5 922.2 L 569.8 941.7 L 587.1 956.2 L 717.0 1031.3 L 732.7 1037.8 L 749.5 1040.0 L 766.3 1037.8 L 782.0 1031.3 L 795.5 1021.0 L 805.8 1007.5 L 812.3 991.8 L 814.5 975.0 L 810.6 952.8 L 799.3 933.3 L 782.0 918.8 L 684.6 862.5 L 684.6 600.0 L 682.4 583.2 L 675.9 567.5 L 665.6 554.0 L 652.1 543.7 L 636.4 537.2 L 619.6 535.0 Z",
      "territoryIds": [
        "naples",
        "rome",
        "switzerland",
        "venice"
      ],
      "color": "#00E5CC",
      "bonusAnchor": {
        "x": 547.23,
        "y": 824.52
      }
    },
    {
      "id": "russia",
      "name": "Rus",
      "bonus": 5,
      "shape": "M 1139.2 85.0 L 1122.5 87.2 L 1106.9 93.7 L 976.8 168.7 L 959.5 183.3 L 948.2 202.8 L 944.3 225.0 L 944.3 375.0 L 948.2 397.2 L 959.5 416.7 L 976.7 431.2 L 1106.7 506.3 L 1122.4 512.8 L 1139.2 515.0 L 1161.4 511.1 L 1180.9 499.8 L 1195.4 482.5 L 1325.4 257.5 L 1331.9 241.8 L 1334.1 225.0 L 1330.2 202.8 L 1318.9 183.3 L 1301.6 168.8 L 1171.7 93.7 L 1156.0 87.2 L 1139.2 85.0 Z",
      "territoryIds": [
        "livonia",
        "moscow",
        "poland",
        "smolensk",
        "st-petersburg",
        "ukraine"
      ],
      "color": "#D32F2F",
      "bonusAnchor": {
        "x": 1261.54,
        "y": 361.27
      }
    },
    {
      "id": "scandinavia",
      "name": "Nordmark",
      "bonus": 3,
      "shape": "M 489.7 10.0 L 472.9 12.2 L 457.2 18.7 L 443.7 29.0 L 433.4 42.5 L 426.9 58.2 L 424.7 75.0 L 428.7 97.2 L 439.9 116.7 L 457.2 131.2 L 587.1 206.3 L 602.8 212.8 L 619.6 215.0 L 636.3 212.8 L 651.9 206.3 L 766.9 140.0 L 1009.3 140.0 L 1029.4 136.8 L 1047.5 127.6 L 1061.9 113.2 L 1071.1 95.1 L 1074.3 75.0 L 1072.1 58.2 L 1065.6 42.5 L 1055.3 29.0 L 1041.8 18.7 L 1026.1 12.2 L 1009.3 10.0 L 489.7 10.0 Z",
      "territoryIds": [
        "denmark",
        "finland",
        "norway",
        "sweden"
      ],
      "color": "#0e9046",
      "bonusAnchor": {
        "x": 617.62,
        "y": 54.93
      }
    },
    {
      "id": "spain",
      "name": "Iberia",
      "bonus": 2,
      "shape": "M 100.0 685.0 L 83.2 687.2 L 67.5 693.7 L 54.0 704.0 L 43.7 717.5 L 37.2 733.2 L 35.0 750.0 L 35.0 900.0 L 37.2 916.8 L 43.7 932.5 L 54.0 946.0 L 67.5 956.3 L 83.2 962.8 L 100.0 965.0 L 116.8 962.8 L 132.4 956.2 L 262.4 881.3 L 279.7 866.7 L 291.0 847.2 L 294.9 825.0 L 291.0 802.8 L 279.7 783.3 L 262.4 768.8 L 132.5 693.7 L 116.8 687.2 L 100.0 685.0 Z",
      "territoryIds": [
        "barcelona",
        "madrid",
        "portugal"
      ],
      "color": "#B0003A",
      "bonusAnchor": {
        "x": 196.16,
        "y": 928.29
      }
    }
  ],
  "territories": [
    {
      "id": "bohemia",
      "name": "Bohemia",
      "regionId": "austria-hungary",
      "adjacencies": [
        "bavaria",
        "galecia",
        "saxony",
        "vienna"
      ],
      "shape": "M 929.4 600.0 L 927.7 612.9 L 922.7 625.0 L 914.8 635.4 L 904.4 643.3 L 892.4 648.3 L 879.4 650.0 L 866.5 648.3 L 854.4 643.3 L 844.1 635.4 L 836.1 625.0 L 831.1 612.9 L 829.4 600.0 L 831.1 587.1 L 836.1 575.0 L 844.1 564.6 L 854.4 556.7 L 866.5 551.7 L 879.4 550.0 L 892.4 551.7 L 904.4 556.7 L 914.8 564.6 L 922.7 575.0 L 927.7 587.1 Z",
      "position": {
        "x": 879.4,
        "y": 600
      },
      "badgeAnchor": {
        "x": 879.4,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "galecia",
      "name": "Red Ruthenia",
      "regionId": "austria-hungary",
      "adjacencies": [
        "bohemia",
        "hungary",
        "poland",
        "romania",
        "saxony",
        "ukraine",
        "vienna"
      ],
      "shape": "M 1059.3 675.0 L 1057.6 687.9 L 1052.6 700.0 L 1044.7 710.4 L 1034.3 718.3 L 1022.2 723.3 L 1009.3 725.0 L 996.4 723.3 L 984.3 718.3 L 973.9 710.4 L 966.0 700.0 L 961.0 687.9 L 959.3 675.0 L 961.0 662.1 L 966.0 650.0 L 973.9 639.6 L 984.3 631.7 L 996.4 626.7 L 1009.3 625.0 L 1022.2 626.7 L 1034.3 631.7 L 1044.7 639.6 L 1052.6 650.0 L 1057.6 662.1 Z",
      "position": {
        "x": 1009.3,
        "y": 675
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 675
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hungary",
      "name": "Pannonia",
      "regionId": "austria-hungary",
      "adjacencies": [
        "galecia",
        "romania",
        "serbia",
        "trieste",
        "vienna"
      ],
      "shape": "M 930.0 750.0 L 928.3 762.9 L 923.3 775.0 L 915.4 785.4 L 905.0 793.3 L 892.9 798.3 L 880.0 800.0 L 867.1 798.3 L 855.0 793.3 L 844.6 785.4 L 836.7 775.0 L 831.7 762.9 L 830.0 750.0 L 831.7 737.1 L 836.7 725.0 L 844.6 714.6 L 855.0 706.7 L 867.1 701.7 L 880.0 700.0 L 892.9 701.7 L 905.0 706.7 L 915.4 714.6 L 923.3 725.0 L 928.3 737.1 Z",
      "position": {
        "x": 880,
        "y": 750
      },
      "badgeAnchor": {
        "x": 880,
        "y": 750
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "trieste",
      "name": "Adriatic Gate",
      "regionId": "austria-hungary",
      "adjacencies": [
        "hungary",
        "montenegro",
        "naples",
        "serbia",
        "venice",
        "vienna"
      ],
      "shape": "M 799.5 825.0 L 797.8 837.9 L 792.8 850.0 L 784.9 860.4 L 774.5 868.3 L 762.5 873.3 L 749.5 875.0 L 736.6 873.3 L 724.5 868.3 L 714.2 860.4 L 706.2 850.0 L 701.2 837.9 L 699.5 825.0 L 701.2 812.1 L 706.2 800.0 L 714.2 789.6 L 724.5 781.7 L 736.6 776.7 L 749.5 775.0 L 762.5 776.7 L 774.5 781.7 L 784.9 789.6 L 792.8 800.0 L 797.8 812.1 Z",
      "position": {
        "x": 749.5,
        "y": 825
      },
      "badgeAnchor": {
        "x": 749.5,
        "y": 825
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vienna",
      "name": "Imperial Seat",
      "regionId": "austria-hungary",
      "adjacencies": [
        "bavaria",
        "bohemia",
        "galecia",
        "hungary",
        "switzerland",
        "trieste",
        "venice"
      ],
      "shape": "M 799.5 675.0 L 797.8 687.9 L 792.8 700.0 L 784.9 710.4 L 774.5 718.3 L 762.5 723.3 L 749.5 725.0 L 736.6 723.3 L 724.5 718.3 L 714.2 710.4 L 706.2 700.0 L 701.2 687.9 L 699.5 675.0 L 701.2 662.1 L 706.2 650.0 L 714.2 639.6 L 724.5 631.7 L 736.6 626.7 L 749.5 625.0 L 762.5 626.7 L 774.5 631.7 L 784.9 639.6 L 792.8 650.0 L 797.8 662.1 Z",
      "position": {
        "x": 749.5,
        "y": 675
      },
      "badgeAnchor": {
        "x": 749.5,
        "y": 675
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bulgaria",
      "name": "Moesia",
      "regionId": "balkans",
      "adjacencies": [
        "greece",
        "romania",
        "serbia",
        "turkey"
      ],
      "shape": "M 1189.2 900.0 L 1187.5 912.9 L 1182.5 925.0 L 1174.6 935.4 L 1164.2 943.3 L 1152.1 948.3 L 1139.2 950.0 L 1126.3 948.3 L 1114.2 943.3 L 1103.8 935.4 L 1095.9 925.0 L 1090.9 912.9 L 1089.2 900.0 L 1090.9 887.1 L 1095.9 875.0 L 1103.8 864.6 L 1114.2 856.7 L 1126.3 851.7 L 1139.2 850.0 L 1152.1 851.7 L 1164.2 856.7 L 1174.6 864.6 L 1182.5 875.0 L 1187.5 887.1 Z",
      "position": {
        "x": 1139.2,
        "y": 900
      },
      "badgeAnchor": {
        "x": 1139.2,
        "y": 900
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "greece",
      "name": "Hellas",
      "regionId": "balkans",
      "adjacencies": [
        "bulgaria",
        "montenegro",
        "serbia",
        "turkey"
      ],
      "shape": "M 1059.3 975.0 L 1057.6 987.9 L 1052.6 1000.0 L 1044.7 1010.3 L 1034.3 1018.3 L 1022.2 1023.3 L 1009.3 1025.0 L 996.4 1023.3 L 984.3 1018.3 L 973.9 1010.3 L 966.0 1000.0 L 961.0 987.9 L 959.3 975.0 L 961.0 962.0 L 966.0 950.0 L 973.9 939.6 L 984.3 931.7 L 996.4 926.7 L 1009.3 925.0 L 1022.2 926.7 L 1034.3 931.7 L 1044.7 939.6 L 1052.6 950.0 L 1057.6 962.0 Z",
      "position": {
        "x": 1009.3,
        "y": 975
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 975
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "montenegro",
      "name": "Black Mountain",
      "regionId": "balkans",
      "adjacencies": [
        "greece",
        "naples",
        "serbia",
        "trieste"
      ],
      "shape": "M 929.4 900.0 L 927.7 912.9 L 922.7 925.0 L 914.8 935.4 L 904.4 943.3 L 892.4 948.3 L 879.4 950.0 L 866.5 948.3 L 854.4 943.3 L 844.1 935.4 L 836.1 925.0 L 831.1 912.9 L 829.4 900.0 L 831.1 887.1 L 836.1 875.0 L 844.1 864.6 L 854.4 856.7 L 866.5 851.7 L 879.4 850.0 L 892.4 851.7 L 904.4 856.7 L 914.8 864.6 L 922.7 875.0 L 927.7 887.1 Z",
      "position": {
        "x": 879.4,
        "y": 900
      },
      "badgeAnchor": {
        "x": 879.4,
        "y": 900
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "romania",
      "name": "Wallachia",
      "regionId": "balkans",
      "adjacencies": [
        "bulgaria",
        "galecia",
        "hungary",
        "serbia",
        "ukraine"
      ],
      "shape": "M 1189.2 750.0 L 1187.5 762.9 L 1182.5 775.0 L 1174.6 785.4 L 1164.2 793.3 L 1152.1 798.3 L 1139.2 800.0 L 1126.3 798.3 L 1114.2 793.3 L 1103.8 785.4 L 1095.9 775.0 L 1090.9 762.9 L 1089.2 750.0 L 1090.9 737.1 L 1095.9 725.0 L 1103.8 714.6 L 1114.2 706.7 L 1126.3 701.7 L 1139.2 700.0 L 1152.1 701.7 L 1164.2 706.7 L 1174.6 714.6 L 1182.5 725.0 L 1187.5 737.1 Z",
      "position": {
        "x": 1139.2,
        "y": 750
      },
      "badgeAnchor": {
        "x": 1139.2,
        "y": 750
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "serbia",
      "name": "Morava",
      "regionId": "balkans",
      "adjacencies": [
        "bulgaria",
        "greece",
        "hungary",
        "montenegro",
        "romania",
        "trieste"
      ],
      "shape": "M 1059.3 825.0 L 1057.6 837.9 L 1052.6 850.0 L 1044.7 860.4 L 1034.3 868.3 L 1022.2 873.3 L 1009.3 875.0 L 996.4 873.3 L 984.3 868.3 L 973.9 860.4 L 966.0 850.0 L 961.0 837.9 L 959.3 825.0 L 961.0 812.1 L 966.0 800.0 L 973.9 789.6 L 984.3 781.7 L 996.4 776.7 L 1009.3 775.0 L 1022.2 776.7 L 1034.3 781.7 L 1044.7 789.6 L 1052.6 800.0 L 1057.6 812.1 Z",
      "position": {
        "x": 1009.3,
        "y": 825
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 825
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "turkey",
      "name": "Anatolia",
      "regionId": "balkans",
      "adjacencies": [
        "bulgaria",
        "greece"
      ],
      "shape": "M 1319.1 975.0 L 1317.4 987.9 L 1312.4 1000.0 L 1304.5 1010.3 L 1294.1 1018.3 L 1282.0 1023.3 L 1269.1 1025.0 L 1256.2 1023.3 L 1244.1 1018.3 L 1233.7 1010.3 L 1225.8 1000.0 L 1220.8 987.9 L 1219.1 975.0 L 1220.8 962.0 L 1225.8 950.0 L 1233.7 939.6 L 1244.1 931.7 L 1256.2 926.7 L 1269.1 925.0 L 1282.0 926.7 L 1294.1 931.7 L 1304.5 939.6 L 1312.4 950.0 L 1317.4 962.0 Z",
      "position": {
        "x": 1269.1,
        "y": 975
      },
      "badgeAnchor": {
        "x": 1269.1,
        "y": 975
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ireland",
      "name": "Erin",
      "regionId": "britain",
      "adjacencies": [
        "scotland",
        "wales"
      ],
      "shape": "M 150.0 300.0 L 148.3 312.9 L 143.3 325.0 L 135.4 335.4 L 125.0 343.3 L 112.9 348.3 L 100.0 350.0 L 87.1 348.3 L 75.0 343.3 L 64.6 335.4 L 56.7 325.0 L 51.7 312.9 L 50.0 300.0 L 51.7 287.1 L 56.7 275.0 L 64.6 264.6 L 75.0 256.7 L 87.1 251.7 L 100.0 250.0 L 112.9 251.7 L 125.0 256.7 L 135.4 264.6 L 143.3 275.0 L 148.3 287.1 Z",
      "position": {
        "x": 100,
        "y": 300
      },
      "badgeAnchor": {
        "x": 100,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "london",
      "name": "Crown City",
      "regionId": "britain",
      "adjacencies": [
        "brittany",
        "burgundy",
        "wales",
        "yorkshire"
      ],
      "shape": "M 409.8 300.0 L 408.1 312.9 L 403.1 325.0 L 395.2 335.4 L 384.8 343.3 L 372.8 348.3 L 359.8 350.0 L 346.9 348.3 L 334.8 343.3 L 324.5 335.4 L 316.5 325.0 L 311.5 312.9 L 309.8 300.0 L 311.5 287.1 L 316.5 275.0 L 324.5 264.6 L 334.8 256.7 L 346.9 251.7 L 359.8 250.0 L 372.8 251.7 L 384.8 256.7 L 395.2 264.6 L 403.1 275.0 L 408.1 287.1 Z",
      "position": {
        "x": 359.8,
        "y": 300
      },
      "badgeAnchor": {
        "x": 359.8,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "scotland",
      "name": "Caledonia",
      "regionId": "britain",
      "adjacencies": [
        "ireland",
        "norway",
        "yorkshire"
      ],
      "shape": "M 279.9 75.0 L 278.2 87.9 L 273.2 100.0 L 265.3 110.4 L 254.9 118.3 L 242.8 123.3 L 229.9 125.0 L 217.0 123.3 L 204.9 118.3 L 194.5 110.4 L 186.6 100.0 L 181.6 87.9 L 179.9 75.0 L 181.6 62.1 L 186.6 50.0 L 194.5 39.6 L 204.9 31.7 L 217.0 26.7 L 229.9 25.0 L 242.8 26.7 L 254.9 31.7 L 265.3 39.6 L 273.2 50.0 L 278.2 62.1 Z",
      "position": {
        "x": 229.9,
        "y": 75
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "wales",
      "name": "Cymru",
      "regionId": "britain",
      "adjacencies": [
        "ireland",
        "london",
        "yorkshire"
      ],
      "shape": "M 279.9 375.0 L 278.2 387.9 L 273.2 400.0 L 265.3 410.4 L 254.9 418.3 L 242.8 423.3 L 229.9 425.0 L 217.0 423.3 L 204.9 418.3 L 194.5 410.4 L 186.6 400.0 L 181.6 387.9 L 179.9 375.0 L 181.6 362.1 L 186.6 350.0 L 194.5 339.6 L 204.9 331.7 L 217.0 326.7 L 229.9 325.0 L 242.8 326.7 L 254.9 331.7 L 265.3 339.6 L 273.2 350.0 L 278.2 362.1 Z",
      "position": {
        "x": 229.9,
        "y": 375
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 375
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "yorkshire",
      "name": "Northmarch",
      "regionId": "britain",
      "adjacencies": [
        "london",
        "scotland",
        "wales"
      ],
      "shape": "M 279.9 225.0 L 278.2 237.9 L 273.2 250.0 L 265.3 260.4 L 254.9 268.3 L 242.8 273.3 L 229.9 275.0 L 217.0 273.3 L 204.9 268.3 L 194.5 260.4 L 186.6 250.0 L 181.6 237.9 L 179.9 225.0 L 181.6 212.1 L 186.6 200.0 L 194.5 189.6 L 204.9 181.7 L 217.0 176.7 L 229.9 175.0 L 242.8 176.7 L 254.9 181.7 L 265.3 189.6 L 273.2 200.0 L 278.2 212.1 Z",
      "position": {
        "x": 229.9,
        "y": 225
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 225
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "brittany",
      "name": "Armorica",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "gascony",
        "london",
        "paris"
      ],
      "shape": "M 279.9 525.0 L 278.2 537.9 L 273.2 550.0 L 265.3 560.4 L 254.9 568.3 L 242.8 573.3 L 229.9 575.0 L 217.0 573.3 L 204.9 568.3 L 194.5 560.4 L 186.6 550.0 L 181.6 537.9 L 179.9 525.0 L 181.6 512.1 L 186.6 500.0 L 194.5 489.6 L 204.9 481.7 L 217.0 476.7 L 229.9 475.0 L 242.8 476.7 L 254.9 481.7 L 265.3 489.6 L 273.2 500.0 L 278.2 512.1 Z",
      "position": {
        "x": 229.9,
        "y": 525
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 525
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "burgundy",
      "name": "Burgundy",
      "regionId": "france",
      "adjacencies": [
        "bavaria",
        "brittany",
        "london",
        "marseille",
        "netherlands",
        "paris",
        "switzerland"
      ],
      "shape": "M 539.7 525.0 L 538.0 537.9 L 533.0 550.0 L 525.1 560.4 L 514.7 568.3 L 502.7 573.3 L 489.7 575.0 L 476.8 573.3 L 464.7 568.3 L 454.4 560.4 L 446.4 550.0 L 441.4 537.9 L 439.7 525.0 L 441.4 512.1 L 446.4 500.0 L 454.4 489.6 L 464.7 481.7 L 476.8 476.7 L 489.7 475.0 L 502.7 476.7 L 514.7 481.7 L 525.1 489.6 L 533.0 500.0 L 538.0 512.1 Z",
      "position": {
        "x": 489.7,
        "y": 525
      },
      "badgeAnchor": {
        "x": 489.7,
        "y": 525
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "gascony",
      "name": "Aquitaine",
      "regionId": "france",
      "adjacencies": [
        "barcelona",
        "brittany",
        "marseille",
        "paris"
      ],
      "shape": "M 279.9 675.0 L 278.2 687.9 L 273.2 700.0 L 265.3 710.4 L 254.9 718.3 L 242.8 723.3 L 229.9 725.0 L 217.0 723.3 L 204.9 718.3 L 194.5 710.4 L 186.6 700.0 L 181.6 687.9 L 179.9 675.0 L 181.6 662.1 L 186.6 650.0 L 194.5 639.6 L 204.9 631.7 L 217.0 626.7 L 229.9 625.0 L 242.8 626.7 L 254.9 631.7 L 265.3 639.6 L 273.2 650.0 L 278.2 662.1 Z",
      "position": {
        "x": 229.9,
        "y": 675
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 675
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "marseille",
      "name": "Provence",
      "regionId": "france",
      "adjacencies": [
        "burgundy",
        "gascony",
        "paris",
        "switzerland",
        "venice"
      ],
      "shape": "M 539.7 675.0 L 538.0 687.9 L 533.0 700.0 L 525.1 710.4 L 514.7 718.3 L 502.7 723.3 L 489.7 725.0 L 476.8 723.3 L 464.7 718.3 L 454.4 710.4 L 446.4 700.0 L 441.4 687.9 L 439.7 675.0 L 441.4 662.1 L 446.4 650.0 L 454.4 639.6 L 464.7 631.7 L 476.8 626.7 L 489.7 625.0 L 502.7 626.7 L 514.7 631.7 L 525.1 639.6 L 533.0 650.0 L 538.0 662.1 Z",
      "position": {
        "x": 489.7,
        "y": 675
      },
      "badgeAnchor": {
        "x": 489.7,
        "y": 675
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "netherlands",
      "name": "Lowlands",
      "regionId": "france",
      "adjacencies": [
        "bavaria",
        "burgundy",
        "rhine"
      ],
      "shape": "M 539.7 375.0 L 538.0 387.9 L 533.0 400.0 L 525.1 410.4 L 514.7 418.3 L 502.7 423.3 L 489.7 425.0 L 476.8 423.3 L 464.7 418.3 L 454.4 410.4 L 446.4 400.0 L 441.4 387.9 L 439.7 375.0 L 441.4 362.1 L 446.4 350.0 L 454.4 339.6 L 464.7 331.7 L 476.8 326.7 L 489.7 325.0 L 502.7 326.7 L 514.7 331.7 L 525.1 339.6 L 533.0 350.0 L 538.0 362.1 Z",
      "position": {
        "x": 489.7,
        "y": 375
      },
      "badgeAnchor": {
        "x": 489.7,
        "y": 375
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "paris",
      "name": "Île-de-France",
      "regionId": "france",
      "adjacencies": [
        "brittany",
        "burgundy",
        "gascony",
        "marseille"
      ],
      "shape": "M 409.8 600.0 L 408.1 612.9 L 403.1 625.0 L 395.2 635.4 L 384.8 643.3 L 372.8 648.3 L 359.8 650.0 L 346.9 648.3 L 334.8 643.3 L 324.5 635.4 L 316.5 625.0 L 311.5 612.9 L 309.8 600.0 L 311.5 587.1 L 316.5 575.0 L 324.5 564.6 L 334.8 556.7 L 346.9 551.7 L 359.8 550.0 L 372.8 551.7 L 384.8 556.7 L 395.2 564.6 L 403.1 575.0 L 408.1 587.1 Z",
      "position": {
        "x": 359.8,
        "y": 600
      },
      "badgeAnchor": {
        "x": 359.8,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "bavaria",
      "name": "Bavaria",
      "regionId": "germany",
      "adjacencies": [
        "berlin",
        "bohemia",
        "burgundy",
        "netherlands",
        "rhine",
        "saxony",
        "switzerland",
        "vienna"
      ],
      "shape": "M 669.6 450.0 L 667.9 462.9 L 662.9 475.0 L 655.0 485.4 L 644.6 493.3 L 632.6 498.3 L 619.6 500.0 L 606.7 498.3 L 594.6 493.3 L 584.3 485.4 L 576.3 475.0 L 571.3 462.9 L 569.6 450.0 L 571.3 437.1 L 576.3 425.0 L 584.3 414.6 L 594.6 406.7 L 606.7 401.7 L 619.6 400.0 L 632.6 401.7 L 644.6 406.7 L 655.0 414.6 L 662.9 425.0 L 667.9 437.1 Z",
      "position": {
        "x": 619.6,
        "y": 450
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "berlin",
      "name": "Brandenburg",
      "regionId": "germany",
      "adjacencies": [
        "bavaria",
        "prussia",
        "rhine",
        "saxony"
      ],
      "shape": "M 799.5 375.0 L 797.8 387.9 L 792.8 400.0 L 784.9 410.4 L 774.5 418.3 L 762.5 423.3 L 749.5 425.0 L 736.6 423.3 L 724.5 418.3 L 714.2 410.4 L 706.2 400.0 L 701.2 387.9 L 699.5 375.0 L 701.2 362.1 L 706.2 350.0 L 714.2 339.6 L 724.5 331.7 L 736.6 326.7 L 749.5 325.0 L 762.5 326.7 L 774.5 331.7 L 784.9 339.6 L 792.8 350.0 L 797.8 362.1 Z",
      "position": {
        "x": 749.5,
        "y": 375
      },
      "badgeAnchor": {
        "x": 749.5,
        "y": 375
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "prussia",
      "name": "Eastmark",
      "regionId": "germany",
      "adjacencies": [
        "berlin",
        "livonia",
        "poland",
        "saxony"
      ],
      "shape": "M 929.4 300.0 L 927.7 312.9 L 922.7 325.0 L 914.8 335.4 L 904.4 343.3 L 892.4 348.3 L 879.4 350.0 L 866.5 348.3 L 854.4 343.3 L 844.1 335.4 L 836.1 325.0 L 831.1 312.9 L 829.4 300.0 L 831.1 287.1 L 836.1 275.0 L 844.1 264.6 L 854.4 256.7 L 866.5 251.7 L 879.4 250.0 L 892.4 251.7 L 904.4 256.7 L 914.8 264.6 L 922.7 275.0 L 927.7 287.1 Z",
      "position": {
        "x": 879.4,
        "y": 300
      },
      "badgeAnchor": {
        "x": 879.4,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rhine",
      "name": "Rhineland",
      "regionId": "germany",
      "adjacencies": [
        "bavaria",
        "berlin",
        "denmark",
        "netherlands"
      ],
      "shape": "M 669.6 300.0 L 667.9 312.9 L 662.9 325.0 L 655.0 335.4 L 644.6 343.3 L 632.6 348.3 L 619.6 350.0 L 606.7 348.3 L 594.6 343.3 L 584.3 335.4 L 576.3 325.0 L 571.3 312.9 L 569.6 300.0 L 571.3 287.1 L 576.3 275.0 L 584.3 264.6 L 594.6 256.7 L 606.7 251.7 L 619.6 250.0 L 632.6 251.7 L 644.6 256.7 L 655.0 264.6 L 662.9 275.0 L 667.9 287.1 Z",
      "position": {
        "x": 619.6,
        "y": 300
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "saxony",
      "name": "Saxonland",
      "regionId": "germany",
      "adjacencies": [
        "bavaria",
        "berlin",
        "bohemia",
        "galecia",
        "poland",
        "prussia"
      ],
      "shape": "M 929.4 450.0 L 927.7 462.9 L 922.7 475.0 L 914.8 485.4 L 904.4 493.3 L 892.4 498.3 L 879.4 500.0 L 866.5 498.3 L 854.4 493.3 L 844.1 485.4 L 836.1 475.0 L 831.1 462.9 L 829.4 450.0 L 831.1 437.1 L 836.1 425.0 L 844.1 414.6 L 854.4 406.7 L 866.5 401.7 L 879.4 400.0 L 892.4 401.7 L 904.4 406.7 L 914.8 414.6 L 922.7 425.0 L 927.7 437.1 Z",
      "position": {
        "x": 879.4,
        "y": 450
      },
      "badgeAnchor": {
        "x": 879.4,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "naples",
      "name": "Campania",
      "regionId": "italy",
      "adjacencies": [
        "montenegro",
        "rome",
        "trieste"
      ],
      "shape": "M 799.5 975.0 L 797.8 987.9 L 792.8 1000.0 L 784.9 1010.3 L 774.5 1018.3 L 762.5 1023.3 L 749.5 1025.0 L 736.6 1023.3 L 724.5 1018.3 L 714.2 1010.3 L 706.2 1000.0 L 701.2 987.9 L 699.5 975.0 L 701.2 962.0 L 706.2 950.0 L 714.2 939.6 L 724.5 931.7 L 736.6 926.7 L 749.5 925.0 L 762.5 926.7 L 774.5 931.7 L 784.9 939.6 L 792.8 950.0 L 797.8 962.0 Z",
      "position": {
        "x": 749.5,
        "y": 975
      },
      "badgeAnchor": {
        "x": 749.5,
        "y": 975
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rome",
      "name": "Latium",
      "regionId": "italy",
      "adjacencies": [
        "naples",
        "venice"
      ],
      "shape": "M 669.6 900.0 L 667.9 912.9 L 662.9 925.0 L 655.0 935.4 L 644.6 943.3 L 632.6 948.3 L 619.6 950.0 L 606.7 948.3 L 594.6 943.3 L 584.3 935.4 L 576.3 925.0 L 571.3 912.9 L 569.6 900.0 L 571.3 887.1 L 576.3 875.0 L 584.3 864.6 L 594.6 856.7 L 606.7 851.7 L 619.6 850.0 L 632.6 851.7 L 644.6 856.7 L 655.0 864.6 L 662.9 875.0 L 667.9 887.1 Z",
      "position": {
        "x": 619.6,
        "y": 900
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 900
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "switzerland",
      "name": "Helvetia",
      "regionId": "italy",
      "adjacencies": [
        "bavaria",
        "burgundy",
        "marseille",
        "venice",
        "vienna"
      ],
      "shape": "M 669.6 600.0 L 667.9 612.9 L 662.9 625.0 L 655.0 635.4 L 644.6 643.3 L 632.6 648.3 L 619.6 650.0 L 606.7 648.3 L 594.6 643.3 L 584.3 635.4 L 576.3 625.0 L 571.3 612.9 L 569.6 600.0 L 571.3 587.1 L 576.3 575.0 L 584.3 564.6 L 594.6 556.7 L 606.7 551.7 L 619.6 550.0 L 632.6 551.7 L 644.6 556.7 L 655.0 564.6 L 662.9 575.0 L 667.9 587.1 Z",
      "position": {
        "x": 619.6,
        "y": 600
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 600
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "venice",
      "name": "Veneto",
      "regionId": "italy",
      "adjacencies": [
        "marseille",
        "rome",
        "switzerland",
        "trieste",
        "vienna"
      ],
      "shape": "M 669.6 750.0 L 667.9 762.9 L 662.9 775.0 L 655.0 785.4 L 644.6 793.3 L 632.6 798.3 L 619.6 800.0 L 606.7 798.3 L 594.6 793.3 L 584.3 785.4 L 576.3 775.0 L 571.3 762.9 L 569.6 750.0 L 571.3 737.1 L 576.3 725.0 L 584.3 714.6 L 594.6 706.7 L 606.7 701.7 L 619.6 700.0 L 632.6 701.7 L 644.6 706.7 L 655.0 714.6 L 662.9 725.0 L 667.9 737.1 Z",
      "position": {
        "x": 619.6,
        "y": 750
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 750
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "livonia",
      "name": "Baltic March",
      "regionId": "russia",
      "adjacencies": [
        "finland",
        "poland",
        "prussia",
        "smolensk",
        "st-petersburg"
      ],
      "shape": "M 1059.3 225.0 L 1057.6 237.9 L 1052.6 250.0 L 1044.7 260.4 L 1034.3 268.3 L 1022.2 273.3 L 1009.3 275.0 L 996.4 273.3 L 984.3 268.3 L 973.9 260.4 L 966.0 250.0 L 961.0 237.9 L 959.3 225.0 L 961.0 212.1 L 966.0 200.0 L 973.9 189.6 L 984.3 181.7 L 996.4 176.7 L 1009.3 175.0 L 1022.2 176.7 L 1034.3 181.7 L 1044.7 189.6 L 1052.6 200.0 L 1057.6 212.1 Z",
      "position": {
        "x": 1009.3,
        "y": 225
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 225
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "moscow",
      "name": "Muscovy",
      "regionId": "russia",
      "adjacencies": [
        "smolensk",
        "st-petersburg",
        "ukraine"
      ],
      "shape": "M 1319.1 225.0 L 1317.4 237.9 L 1312.4 250.0 L 1304.5 260.4 L 1294.1 268.3 L 1282.0 273.3 L 1269.1 275.0 L 1256.2 273.3 L 1244.1 268.3 L 1233.7 260.4 L 1225.8 250.0 L 1220.8 237.9 L 1219.1 225.0 L 1220.8 212.1 L 1225.8 200.0 L 1233.7 189.6 L 1244.1 181.7 L 1256.2 176.7 L 1269.1 175.0 L 1282.0 176.7 L 1294.1 181.7 L 1304.5 189.6 L 1312.4 200.0 L 1317.4 212.1 Z",
      "position": {
        "x": 1269.1,
        "y": 225
      },
      "badgeAnchor": {
        "x": 1269.1,
        "y": 225
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "poland",
      "name": "Vistula",
      "regionId": "russia",
      "adjacencies": [
        "galecia",
        "livonia",
        "prussia",
        "saxony",
        "smolensk",
        "ukraine"
      ],
      "shape": "M 1059.3 375.0 L 1057.6 387.9 L 1052.6 400.0 L 1044.7 410.4 L 1034.3 418.3 L 1022.2 423.3 L 1009.3 425.0 L 996.4 423.3 L 984.3 418.3 L 973.9 410.4 L 966.0 400.0 L 961.0 387.9 L 959.3 375.0 L 961.0 362.1 L 966.0 350.0 L 973.9 339.6 L 984.3 331.7 L 996.4 326.7 L 1009.3 325.0 L 1022.2 326.7 L 1034.3 331.7 L 1044.7 339.6 L 1052.6 350.0 L 1057.6 362.1 Z",
      "position": {
        "x": 1009.3,
        "y": 375
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 375
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "smolensk",
      "name": "Western Gate",
      "regionId": "russia",
      "adjacencies": [
        "livonia",
        "moscow",
        "poland",
        "st-petersburg",
        "ukraine"
      ],
      "shape": "M 1189.2 300.0 L 1187.5 312.9 L 1182.5 325.0 L 1174.6 335.4 L 1164.2 343.3 L 1152.1 348.3 L 1139.2 350.0 L 1126.3 348.3 L 1114.2 343.3 L 1103.8 335.4 L 1095.9 325.0 L 1090.9 312.9 L 1089.2 300.0 L 1090.9 287.1 L 1095.9 275.0 L 1103.8 264.6 L 1114.2 256.7 L 1126.3 251.7 L 1139.2 250.0 L 1152.1 251.7 L 1164.2 256.7 L 1174.6 264.6 L 1182.5 275.0 L 1187.5 287.1 Z",
      "position": {
        "x": 1139.2,
        "y": 300
      },
      "badgeAnchor": {
        "x": 1139.2,
        "y": 300
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "st-petersburg",
      "name": "Neva",
      "regionId": "russia",
      "adjacencies": [
        "finland",
        "livonia",
        "moscow",
        "smolensk"
      ],
      "shape": "M 1189.2 150.0 L 1187.5 162.9 L 1182.5 175.0 L 1174.6 185.4 L 1164.2 193.3 L 1152.1 198.3 L 1139.2 200.0 L 1126.3 198.3 L 1114.2 193.3 L 1103.8 185.4 L 1095.9 175.0 L 1090.9 162.9 L 1089.2 150.0 L 1090.9 137.1 L 1095.9 125.0 L 1103.8 114.6 L 1114.2 106.7 L 1126.3 101.7 L 1139.2 100.0 L 1152.1 101.7 L 1164.2 106.7 L 1174.6 114.6 L 1182.5 125.0 L 1187.5 137.1 Z",
      "position": {
        "x": 1139.2,
        "y": 150
      },
      "badgeAnchor": {
        "x": 1139.2,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ukraine",
      "name": "Dnieper",
      "regionId": "russia",
      "adjacencies": [
        "galecia",
        "moscow",
        "poland",
        "romania",
        "smolensk"
      ],
      "shape": "M 1189.2 450.0 L 1187.5 462.9 L 1182.5 475.0 L 1174.6 485.4 L 1164.2 493.3 L 1152.1 498.3 L 1139.2 500.0 L 1126.3 498.3 L 1114.2 493.3 L 1103.8 485.4 L 1095.9 475.0 L 1090.9 462.9 L 1089.2 450.0 L 1090.9 437.1 L 1095.9 425.0 L 1103.8 414.6 L 1114.2 406.7 L 1126.3 401.7 L 1139.2 400.0 L 1152.1 401.7 L 1164.2 406.7 L 1174.6 414.6 L 1182.5 425.0 L 1187.5 437.1 Z",
      "position": {
        "x": 1139.2,
        "y": 450
      },
      "badgeAnchor": {
        "x": 1139.2,
        "y": 450
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "denmark",
      "name": "Jutland",
      "regionId": "scandinavia",
      "adjacencies": [
        "norway",
        "rhine",
        "sweden"
      ],
      "shape": "M 669.6 150.0 L 667.9 162.9 L 662.9 175.0 L 655.0 185.4 L 644.6 193.3 L 632.6 198.3 L 619.6 200.0 L 606.7 198.3 L 594.6 193.3 L 584.3 185.4 L 576.3 175.0 L 571.3 162.9 L 569.6 150.0 L 571.3 137.1 L 576.3 125.0 L 584.3 114.6 L 594.6 106.7 L 606.7 101.7 L 619.6 100.0 L 632.6 101.7 L 644.6 106.7 L 655.0 114.6 L 662.9 125.0 L 667.9 137.1 Z",
      "position": {
        "x": 619.6,
        "y": 150
      },
      "badgeAnchor": {
        "x": 619.6,
        "y": 150
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "finland",
      "name": "The Northlands",
      "regionId": "scandinavia",
      "adjacencies": [
        "livonia",
        "st-petersburg",
        "sweden"
      ],
      "shape": "M 1059.3 75.0 L 1057.6 87.9 L 1052.6 100.0 L 1044.7 110.4 L 1034.3 118.3 L 1022.2 123.3 L 1009.3 125.0 L 996.4 123.3 L 984.3 118.3 L 973.9 110.4 L 966.0 100.0 L 961.0 87.9 L 959.3 75.0 L 961.0 62.1 L 966.0 50.0 L 973.9 39.6 L 984.3 31.7 L 996.4 26.7 L 1009.3 25.0 L 1022.2 26.7 L 1034.3 31.7 L 1044.7 39.6 L 1052.6 50.0 L 1057.6 62.1 Z",
      "position": {
        "x": 1009.3,
        "y": 75
      },
      "badgeAnchor": {
        "x": 1009.3,
        "y": 75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "norway",
      "name": "Fjordland",
      "regionId": "scandinavia",
      "adjacencies": [
        "denmark",
        "scotland",
        "sweden"
      ],
      "shape": "M 539.7 75.0 L 538.0 87.9 L 533.0 100.0 L 525.1 110.4 L 514.7 118.3 L 502.7 123.3 L 489.7 125.0 L 476.8 123.3 L 464.7 118.3 L 454.4 110.4 L 446.4 100.0 L 441.4 87.9 L 439.7 75.0 L 441.4 62.1 L 446.4 50.0 L 454.4 39.6 L 464.7 31.7 L 476.8 26.7 L 489.7 25.0 L 502.7 26.7 L 514.7 31.7 L 525.1 39.6 L 533.0 50.0 L 538.0 62.1 Z",
      "position": {
        "x": 489.7,
        "y": 75
      },
      "badgeAnchor": {
        "x": 489.7,
        "y": 75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sweden",
      "name": "Svealand",
      "regionId": "scandinavia",
      "adjacencies": [
        "denmark",
        "finland",
        "norway"
      ],
      "shape": "M 799.5 75.0 L 797.8 87.9 L 792.8 100.0 L 784.9 110.4 L 774.5 118.3 L 762.5 123.3 L 749.5 125.0 L 736.6 123.3 L 724.5 118.3 L 714.2 110.4 L 706.2 100.0 L 701.2 87.9 L 699.5 75.0 L 701.2 62.1 L 706.2 50.0 L 714.2 39.6 L 724.5 31.7 L 736.6 26.7 L 749.5 25.0 L 762.5 26.7 L 774.5 31.7 L 784.9 39.6 L 792.8 50.0 L 797.8 62.1 Z",
      "position": {
        "x": 749.5,
        "y": 75
      },
      "badgeAnchor": {
        "x": 749.5,
        "y": 75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "barcelona",
      "name": "Catalonia",
      "regionId": "spain",
      "adjacencies": [
        "gascony",
        "madrid",
        "portugal"
      ],
      "shape": "M 150.0 750.0 L 148.3 762.9 L 143.3 775.0 L 135.4 785.4 L 125.0 793.3 L 112.9 798.3 L 100.0 800.0 L 87.1 798.3 L 75.0 793.3 L 64.6 785.4 L 56.7 775.0 L 51.7 762.9 L 50.0 750.0 L 51.7 737.1 L 56.7 725.0 L 64.6 714.6 L 75.0 706.7 L 87.1 701.7 L 100.0 700.0 L 112.9 701.7 L 125.0 706.7 L 135.4 714.6 L 143.3 725.0 L 148.3 737.1 Z",
      "position": {
        "x": 100,
        "y": 750
      },
      "badgeAnchor": {
        "x": 100,
        "y": 750
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "madrid",
      "name": "Castile",
      "regionId": "spain",
      "adjacencies": [
        "barcelona",
        "portugal"
      ],
      "shape": "M 279.9 825.0 L 278.2 837.9 L 273.2 850.0 L 265.3 860.4 L 254.9 868.3 L 242.8 873.3 L 229.9 875.0 L 217.0 873.3 L 204.9 868.3 L 194.5 860.4 L 186.6 850.0 L 181.6 837.9 L 179.9 825.0 L 181.6 812.1 L 186.6 800.0 L 194.5 789.6 L 204.9 781.7 L 217.0 776.7 L 229.9 775.0 L 242.8 776.7 L 254.9 781.7 L 265.3 789.6 L 273.2 800.0 L 278.2 812.1 Z",
      "position": {
        "x": 229.9,
        "y": 825
      },
      "badgeAnchor": {
        "x": 229.9,
        "y": 825
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "portugal",
      "name": "Lusitania",
      "regionId": "spain",
      "adjacencies": [
        "barcelona",
        "madrid"
      ],
      "shape": "M 150.0 900.0 L 148.3 912.9 L 143.3 925.0 L 135.4 935.4 L 125.0 943.3 L 112.9 948.3 L 100.0 950.0 L 87.1 948.3 L 75.0 943.3 L 64.6 935.4 L 56.7 925.0 L 51.7 912.9 L 50.0 900.0 L 51.7 887.1 L 56.7 875.0 L 64.6 864.6 L 75.0 856.7 L 87.1 851.7 L 100.0 850.0 L 112.9 851.7 L 125.0 856.7 L 135.4 864.6 L 143.3 875.0 L 148.3 887.1 Z",
      "position": {
        "x": 100,
        "y": 900
      },
      "badgeAnchor": {
        "x": 100,
        "y": 900
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-c5d5c12a-487618a0",
  "seaRoutes": [
    {
      "aId": "bohemia",
      "bId": "bavaria",
      "from": {
        "x": 836.1,
        "y": 575
      },
      "to": {
        "x": 662.9,
        "y": 475
      }
    },
    {
      "aId": "bohemia",
      "bId": "galecia",
      "from": {
        "x": 922.7,
        "y": 625
      },
      "to": {
        "x": 966,
        "y": 650
      }
    },
    {
      "aId": "bohemia",
      "bId": "saxony",
      "from": {
        "x": 879.4,
        "y": 550
      },
      "to": {
        "x": 879.4,
        "y": 500
      }
    },
    {
      "aId": "bohemia",
      "bId": "vienna",
      "from": {
        "x": 836.1,
        "y": 625
      },
      "to": {
        "x": 792.8,
        "y": 650
      }
    },
    {
      "aId": "galecia",
      "bId": "hungary",
      "from": {
        "x": 966,
        "y": 700
      },
      "to": {
        "x": 923.3,
        "y": 725
      }
    },
    {
      "aId": "galecia",
      "bId": "poland",
      "from": {
        "x": 1009.3,
        "y": 625
      },
      "to": {
        "x": 1009.3,
        "y": 425
      }
    },
    {
      "aId": "galecia",
      "bId": "romania",
      "from": {
        "x": 1052.6,
        "y": 700
      },
      "to": {
        "x": 1095.9,
        "y": 725
      }
    },
    {
      "aId": "galecia",
      "bId": "saxony",
      "from": {
        "x": 984.3,
        "y": 631.7
      },
      "to": {
        "x": 904.4,
        "y": 493.3
      }
    },
    {
      "aId": "galecia",
      "bId": "ukraine",
      "from": {
        "x": 1034.3,
        "y": 631.7
      },
      "to": {
        "x": 1114.2,
        "y": 493.3
      }
    },
    {
      "aId": "galecia",
      "bId": "vienna",
      "from": {
        "x": 959.3,
        "y": 675
      },
      "to": {
        "x": 799.5,
        "y": 675
      }
    },
    {
      "aId": "hungary",
      "bId": "romania",
      "from": {
        "x": 930,
        "y": 750
      },
      "to": {
        "x": 1089.2,
        "y": 750
      }
    },
    {
      "aId": "hungary",
      "bId": "serbia",
      "from": {
        "x": 923.3,
        "y": 775
      },
      "to": {
        "x": 966,
        "y": 800
      }
    },
    {
      "aId": "hungary",
      "bId": "trieste",
      "from": {
        "x": 836.7,
        "y": 775
      },
      "to": {
        "x": 792.8,
        "y": 800
      }
    },
    {
      "aId": "hungary",
      "bId": "vienna",
      "from": {
        "x": 836.7,
        "y": 725
      },
      "to": {
        "x": 792.8,
        "y": 700
      }
    },
    {
      "aId": "trieste",
      "bId": "montenegro",
      "from": {
        "x": 792.8,
        "y": 850
      },
      "to": {
        "x": 836.1,
        "y": 875
      }
    },
    {
      "aId": "trieste",
      "bId": "naples",
      "from": {
        "x": 749.5,
        "y": 875
      },
      "to": {
        "x": 749.5,
        "y": 925
      }
    },
    {
      "aId": "trieste",
      "bId": "serbia",
      "from": {
        "x": 799.5,
        "y": 825
      },
      "to": {
        "x": 959.3,
        "y": 825
      }
    },
    {
      "aId": "trieste",
      "bId": "venice",
      "from": {
        "x": 706.2,
        "y": 800
      },
      "to": {
        "x": 662.9,
        "y": 775
      }
    },
    {
      "aId": "trieste",
      "bId": "vienna",
      "from": {
        "x": 749.5,
        "y": 775
      },
      "to": {
        "x": 749.5,
        "y": 725
      }
    },
    {
      "aId": "vienna",
      "bId": "bavaria",
      "from": {
        "x": 724.5,
        "y": 631.7
      },
      "to": {
        "x": 644.6,
        "y": 493.3
      }
    },
    {
      "aId": "vienna",
      "bId": "switzerland",
      "from": {
        "x": 706.2,
        "y": 650
      },
      "to": {
        "x": 662.9,
        "y": 625
      }
    },
    {
      "aId": "vienna",
      "bId": "venice",
      "from": {
        "x": 706.2,
        "y": 700
      },
      "to": {
        "x": 662.9,
        "y": 725
      }
    },
    {
      "aId": "bulgaria",
      "bId": "greece",
      "from": {
        "x": 1095.9,
        "y": 925
      },
      "to": {
        "x": 1052.6,
        "y": 950
      }
    },
    {
      "aId": "bulgaria",
      "bId": "romania",
      "from": {
        "x": 1139.2,
        "y": 850
      },
      "to": {
        "x": 1139.2,
        "y": 800
      }
    },
    {
      "aId": "bulgaria",
      "bId": "serbia",
      "from": {
        "x": 1095.9,
        "y": 875
      },
      "to": {
        "x": 1052.6,
        "y": 850
      }
    },
    {
      "aId": "bulgaria",
      "bId": "turkey",
      "from": {
        "x": 1182.5,
        "y": 925
      },
      "to": {
        "x": 1225.8,
        "y": 950
      }
    },
    {
      "aId": "greece",
      "bId": "montenegro",
      "from": {
        "x": 966,
        "y": 950
      },
      "to": {
        "x": 922.7,
        "y": 925
      }
    },
    {
      "aId": "greece",
      "bId": "serbia",
      "from": {
        "x": 1009.3,
        "y": 925
      },
      "to": {
        "x": 1009.3,
        "y": 875
      }
    },
    {
      "aId": "greece",
      "bId": "turkey",
      "from": {
        "x": 1059.3,
        "y": 975
      },
      "to": {
        "x": 1219.1,
        "y": 975
      }
    },
    {
      "aId": "montenegro",
      "bId": "naples",
      "from": {
        "x": 836.1,
        "y": 925
      },
      "to": {
        "x": 792.8,
        "y": 950
      }
    },
    {
      "aId": "montenegro",
      "bId": "serbia",
      "from": {
        "x": 922.7,
        "y": 875
      },
      "to": {
        "x": 966,
        "y": 850
      }
    },
    {
      "aId": "romania",
      "bId": "serbia",
      "from": {
        "x": 1095.9,
        "y": 775
      },
      "to": {
        "x": 1052.6,
        "y": 800
      }
    },
    {
      "aId": "romania",
      "bId": "ukraine",
      "from": {
        "x": 1139.2,
        "y": 700
      },
      "to": {
        "x": 1139.2,
        "y": 500
      }
    },
    {
      "aId": "ireland",
      "bId": "scotland",
      "from": {
        "x": 125,
        "y": 256.7
      },
      "to": {
        "x": 204.9,
        "y": 118.3
      }
    },
    {
      "aId": "ireland",
      "bId": "wales",
      "from": {
        "x": 143.3,
        "y": 325
      },
      "to": {
        "x": 186.6,
        "y": 350
      }
    },
    {
      "aId": "london",
      "bId": "brittany",
      "from": {
        "x": 334.8,
        "y": 343.3
      },
      "to": {
        "x": 254.9,
        "y": 481.7
      }
    },
    {
      "aId": "london",
      "bId": "burgundy",
      "from": {
        "x": 384.8,
        "y": 343.3
      },
      "to": {
        "x": 464.7,
        "y": 481.7
      }
    },
    {
      "aId": "london",
      "bId": "wales",
      "from": {
        "x": 316.5,
        "y": 325
      },
      "to": {
        "x": 273.2,
        "y": 350
      }
    },
    {
      "aId": "london",
      "bId": "yorkshire",
      "from": {
        "x": 316.5,
        "y": 275
      },
      "to": {
        "x": 273.2,
        "y": 250
      }
    },
    {
      "aId": "scotland",
      "bId": "norway",
      "from": {
        "x": 279.9,
        "y": 75
      },
      "to": {
        "x": 439.7,
        "y": 75
      }
    },
    {
      "aId": "scotland",
      "bId": "yorkshire",
      "from": {
        "x": 229.9,
        "y": 125
      },
      "to": {
        "x": 229.9,
        "y": 175
      }
    },
    {
      "aId": "wales",
      "bId": "yorkshire",
      "from": {
        "x": 229.9,
        "y": 325
      },
      "to": {
        "x": 229.9,
        "y": 275
      }
    },
    {
      "aId": "brittany",
      "bId": "burgundy",
      "from": {
        "x": 279.9,
        "y": 525
      },
      "to": {
        "x": 439.7,
        "y": 525
      }
    },
    {
      "aId": "brittany",
      "bId": "gascony",
      "from": {
        "x": 229.9,
        "y": 575
      },
      "to": {
        "x": 229.9,
        "y": 625
      }
    },
    {
      "aId": "brittany",
      "bId": "paris",
      "from": {
        "x": 273.2,
        "y": 550
      },
      "to": {
        "x": 316.5,
        "y": 575
      }
    },
    {
      "aId": "burgundy",
      "bId": "bavaria",
      "from": {
        "x": 533,
        "y": 500
      },
      "to": {
        "x": 576.3,
        "y": 475
      }
    },
    {
      "aId": "burgundy",
      "bId": "marseille",
      "from": {
        "x": 489.7,
        "y": 575
      },
      "to": {
        "x": 489.7,
        "y": 625
      }
    },
    {
      "aId": "burgundy",
      "bId": "netherlands",
      "from": {
        "x": 489.7,
        "y": 475
      },
      "to": {
        "x": 489.7,
        "y": 425
      }
    },
    {
      "aId": "burgundy",
      "bId": "paris",
      "from": {
        "x": 446.4,
        "y": 550
      },
      "to": {
        "x": 403.1,
        "y": 575
      }
    },
    {
      "aId": "burgundy",
      "bId": "switzerland",
      "from": {
        "x": 533,
        "y": 550
      },
      "to": {
        "x": 576.3,
        "y": 575
      }
    },
    {
      "aId": "gascony",
      "bId": "barcelona",
      "from": {
        "x": 186.6,
        "y": 700
      },
      "to": {
        "x": 143.3,
        "y": 725
      }
    },
    {
      "aId": "gascony",
      "bId": "marseille",
      "from": {
        "x": 279.9,
        "y": 675
      },
      "to": {
        "x": 439.7,
        "y": 675
      }
    },
    {
      "aId": "gascony",
      "bId": "paris",
      "from": {
        "x": 273.2,
        "y": 650
      },
      "to": {
        "x": 316.5,
        "y": 625
      }
    },
    {
      "aId": "marseille",
      "bId": "paris",
      "from": {
        "x": 446.4,
        "y": 650
      },
      "to": {
        "x": 403.1,
        "y": 625
      }
    },
    {
      "aId": "marseille",
      "bId": "switzerland",
      "from": {
        "x": 533,
        "y": 650
      },
      "to": {
        "x": 576.3,
        "y": 625
      }
    },
    {
      "aId": "marseille",
      "bId": "venice",
      "from": {
        "x": 533,
        "y": 700
      },
      "to": {
        "x": 576.3,
        "y": 725
      }
    },
    {
      "aId": "netherlands",
      "bId": "bavaria",
      "from": {
        "x": 533,
        "y": 400
      },
      "to": {
        "x": 576.3,
        "y": 425
      }
    },
    {
      "aId": "netherlands",
      "bId": "rhine",
      "from": {
        "x": 533,
        "y": 350
      },
      "to": {
        "x": 576.3,
        "y": 325
      }
    },
    {
      "aId": "bavaria",
      "bId": "berlin",
      "from": {
        "x": 662.9,
        "y": 425
      },
      "to": {
        "x": 706.2,
        "y": 400
      }
    },
    {
      "aId": "bavaria",
      "bId": "rhine",
      "from": {
        "x": 619.6,
        "y": 400
      },
      "to": {
        "x": 619.6,
        "y": 350
      }
    },
    {
      "aId": "bavaria",
      "bId": "saxony",
      "from": {
        "x": 669.6,
        "y": 450
      },
      "to": {
        "x": 829.4,
        "y": 450
      }
    },
    {
      "aId": "bavaria",
      "bId": "switzerland",
      "from": {
        "x": 619.6,
        "y": 500
      },
      "to": {
        "x": 619.6,
        "y": 550
      }
    },
    {
      "aId": "berlin",
      "bId": "prussia",
      "from": {
        "x": 792.8,
        "y": 350
      },
      "to": {
        "x": 836.1,
        "y": 325
      }
    },
    {
      "aId": "berlin",
      "bId": "rhine",
      "from": {
        "x": 706.2,
        "y": 350
      },
      "to": {
        "x": 662.9,
        "y": 325
      }
    },
    {
      "aId": "berlin",
      "bId": "saxony",
      "from": {
        "x": 792.8,
        "y": 400
      },
      "to": {
        "x": 836.1,
        "y": 425
      }
    },
    {
      "aId": "prussia",
      "bId": "livonia",
      "from": {
        "x": 922.7,
        "y": 275
      },
      "to": {
        "x": 966,
        "y": 250
      }
    },
    {
      "aId": "prussia",
      "bId": "poland",
      "from": {
        "x": 922.7,
        "y": 325
      },
      "to": {
        "x": 966,
        "y": 350
      }
    },
    {
      "aId": "prussia",
      "bId": "saxony",
      "from": {
        "x": 879.4,
        "y": 350
      },
      "to": {
        "x": 879.4,
        "y": 400
      }
    },
    {
      "aId": "rhine",
      "bId": "denmark",
      "from": {
        "x": 619.6,
        "y": 250
      },
      "to": {
        "x": 619.6,
        "y": 200
      }
    },
    {
      "aId": "saxony",
      "bId": "poland",
      "from": {
        "x": 922.7,
        "y": 425
      },
      "to": {
        "x": 966,
        "y": 400
      }
    },
    {
      "aId": "naples",
      "bId": "rome",
      "from": {
        "x": 706.2,
        "y": 950
      },
      "to": {
        "x": 662.9,
        "y": 925
      }
    },
    {
      "aId": "rome",
      "bId": "venice",
      "from": {
        "x": 619.6,
        "y": 850
      },
      "to": {
        "x": 619.6,
        "y": 800
      }
    },
    {
      "aId": "switzerland",
      "bId": "venice",
      "from": {
        "x": 619.6,
        "y": 650
      },
      "to": {
        "x": 619.6,
        "y": 700
      }
    },
    {
      "aId": "livonia",
      "bId": "finland",
      "from": {
        "x": 1009.3,
        "y": 175
      },
      "to": {
        "x": 1009.3,
        "y": 125
      }
    },
    {
      "aId": "livonia",
      "bId": "poland",
      "from": {
        "x": 1009.3,
        "y": 275
      },
      "to": {
        "x": 1009.3,
        "y": 325
      }
    },
    {
      "aId": "livonia",
      "bId": "smolensk",
      "from": {
        "x": 1052.6,
        "y": 250
      },
      "to": {
        "x": 1095.9,
        "y": 275
      }
    },
    {
      "aId": "livonia",
      "bId": "st-petersburg",
      "from": {
        "x": 1052.6,
        "y": 200
      },
      "to": {
        "x": 1095.9,
        "y": 175
      }
    },
    {
      "aId": "moscow",
      "bId": "smolensk",
      "from": {
        "x": 1225.8,
        "y": 250
      },
      "to": {
        "x": 1182.5,
        "y": 275
      }
    },
    {
      "aId": "moscow",
      "bId": "st-petersburg",
      "from": {
        "x": 1225.8,
        "y": 200
      },
      "to": {
        "x": 1182.5,
        "y": 175
      }
    },
    {
      "aId": "moscow",
      "bId": "ukraine",
      "from": {
        "x": 1244.1,
        "y": 268.3
      },
      "to": {
        "x": 1164.2,
        "y": 406.7
      }
    },
    {
      "aId": "poland",
      "bId": "smolensk",
      "from": {
        "x": 1052.6,
        "y": 350
      },
      "to": {
        "x": 1095.9,
        "y": 325
      }
    },
    {
      "aId": "poland",
      "bId": "ukraine",
      "from": {
        "x": 1052.6,
        "y": 400
      },
      "to": {
        "x": 1095.9,
        "y": 425
      }
    },
    {
      "aId": "smolensk",
      "bId": "st-petersburg",
      "from": {
        "x": 1139.2,
        "y": 250
      },
      "to": {
        "x": 1139.2,
        "y": 200
      }
    },
    {
      "aId": "smolensk",
      "bId": "ukraine",
      "from": {
        "x": 1139.2,
        "y": 350
      },
      "to": {
        "x": 1139.2,
        "y": 400
      }
    },
    {
      "aId": "st-petersburg",
      "bId": "finland",
      "from": {
        "x": 1095.9,
        "y": 125
      },
      "to": {
        "x": 1052.6,
        "y": 100
      }
    },
    {
      "aId": "denmark",
      "bId": "norway",
      "from": {
        "x": 576.3,
        "y": 125
      },
      "to": {
        "x": 533,
        "y": 100
      }
    },
    {
      "aId": "denmark",
      "bId": "sweden",
      "from": {
        "x": 662.9,
        "y": 125
      },
      "to": {
        "x": 706.2,
        "y": 100
      }
    },
    {
      "aId": "finland",
      "bId": "sweden",
      "from": {
        "x": 959.3,
        "y": 75
      },
      "to": {
        "x": 799.5,
        "y": 75
      }
    },
    {
      "aId": "norway",
      "bId": "sweden",
      "from": {
        "x": 539.7,
        "y": 75
      },
      "to": {
        "x": 699.5,
        "y": 75
      }
    },
    {
      "aId": "barcelona",
      "bId": "madrid",
      "from": {
        "x": 143.3,
        "y": 775
      },
      "to": {
        "x": 186.6,
        "y": 800
      }
    },
    {
      "aId": "barcelona",
      "bId": "portugal",
      "from": {
        "x": 100,
        "y": 800
      },
      "to": {
        "x": 100,
        "y": 850
      }
    },
    {
      "aId": "madrid",
      "bId": "portugal",
      "from": {
        "x": 186.6,
        "y": 850
      },
      "to": {
        "x": 143.3,
        "y": 875
      }
    }
  ]
}
